import { List, ListItem } from "@mui/material";
import { useTranslation } from "react-i18next";

import { InboundDeliveryFragment } from "../../../../../models/autogenerated-deliveryService-gql/graphql";

interface DetailsStatusTabProps {
  delivery: InboundDeliveryFragment;
}

const DetailsStatusTab = (props: DetailsStatusTabProps) => {
  const { t } = useTranslation();
  const { delivery } = props;
  const {
    status,
    timeSlotBookingStatus,
    quantityConfirmationStatus,
    deliveryDateConfirmationStatus,
  } = delivery;

  return (
    <List>
      <ListItem>
        {`${t("delivery")}:`}
        <div className={"ml-10 status-badge status-badge-" + status}>
          {t(status)}
        </div>
      </ListItem>
      <ListItem>
        {`${t("timeSlotBooking")}:`}
        <div
          className={"ml-10 status-badge status-badge-" + timeSlotBookingStatus}
        >
          {t(timeSlotBookingStatus)}
        </div>
      </ListItem>
      <ListItem>
        {`${t("quantityConfirmation")}:`}
        <div
          className={
            "ml-10 status-badge status-badge-" + quantityConfirmationStatus
          }
        >
          {t(quantityConfirmationStatus)}
        </div>
      </ListItem>
      <ListItem>
        {`${t("deliveryDateConfirmation")}:`}
        <div
          className={
            "ml-10 status-badge status-badge-" + deliveryDateConfirmationStatus
          }
        >
          {t(deliveryDateConfirmationStatus)}
        </div>
      </ListItem>
    </List>
  );
};

export default DetailsStatusTab;
